import Crown2 from '@assets/icons/crown-2.svg'
import { Icon } from './Icon'

export const Crown2Icon = Icon(Crown2)
